import React, { useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";

import "./Login.css";

import logo from "../../images/logo.png";

const Login = () => {
    const [userName, setUserName] = useState(null);
    const [password, setPassword] = useState(null);

    let user = { userType: 0, isLoggedIn: false };
    console.log(user);
    const setLogin = () => {
        if (userName === "admin" && password === "admin@2021") {
            user = { userType: 1, isLoggedIn: true };
        }
        localStorage.setItem("isLoggedIn", user.isLoggedIn);
        localStorage.setItem("userType", user.userType);

        window.location.reload(false);
    };

    return (
        <div className="my_card">
            <div className="Heading">
                {/* <img
                    src={logo}
                    alt="logo"
                    className="img-fluid"
                    width={300}
                    height={200}
                /> */}
            </div>
            <div className="card_1">
                <div>
                    <div className="Wrapper">
                        <p className="my_p">Sign in to start your session</p>
                        <label for="inputEmail4" className="form-label"></label>
                        <input
                            type="text"
                            className="form-control my_css"
                            id="userName"
                            placeholder="User name"
                            onChange={(e) => {
                                setUserName(e.target.value);
                            }}
                        />
                    </div>
                    <div className="">
                        <label for="inputPassword4" className="form-label"></label>
                        <input
                            type="password"
                            className="form-control"
                            id="inputPassword4"
                            placeholder="Password"
                            onChange={(e) => {
                                setPassword(e.target.value);
                            }}
                        />
                    </div>
                    <div className="flex my_css">
                        <div className="">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={setLogin}
                            >
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
